import React from 'react';
import { Page, useCheckUpRouter } from '../../router/context';
import * as S from './styles';
import CheckupDigitalDetails from './components/CheckupDigitalDetails';
import { ServiceItemProps } from '../../../../models/Service';
import { CheckupDigitalDetailsWithoutExams } from './components/CheckupDigitalDetailsWithoutExams';

export type CheckUpInfoPageProps = {
  isFirstAppointment: boolean;
  service: ServiceItemProps;
  patient: any;
  elegibility: any;
  externalExams: boolean;
  firstAppointmentDate: string;
};
export function CheckUpInfoPage(props: CheckUpInfoPageProps) {
  const router = useCheckUpRouter();

  const navigate = () => {
    if (props.service.products.length === 1) {
      router.navigate(Page.PRODUCT_SLOTS, {
        ...props,
        products: props?.service?.products
      });
    } else {
      router.navigate(Page.PRODUCT_LIST, props);
    }
  };

  return (
    <S.Container>
      {props.externalExams && !props?.isFirstAppointment ? (
        <CheckupDigitalDetailsWithoutExams onClose={router.goBack} handleContinue={navigate} />
      ) : (
        <CheckupDigitalDetails
          handleAddProductList={navigate}
          isFirstAppointment={props?.isFirstAppointment}
          onClose={router.goBack}
          service={{} as any}
        />
      )}
    </S.Container>
  );
}
